// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"428":"6267bcd2","2840":"6d663ee8","4294":"ff02a6e4","4302":"6267bcd2","4950":"80ce0b95"}[chunkId] + ".chunk.css";
};